import { render } from "./ExternalLayout.vue?vue&type=template&id=151a7550"
import script from "./ExternalLayout.vue?vue&type=script&lang=js"
export * from "./ExternalLayout.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mobilemediaru/cashforapp/cashforapp_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__